const loginFormStyles = (theme) => ({
  msSignIn: {
    display: "flex",
    marginBottom: theme.spacing(1),
  },
  msSignInButton: {
    maxWidth: "max-content",
  },
  form: {
    flexGrow: 1,
    minWidth: 302,
    maxWidth: 328,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(3),
  },
  button: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2.5),
    padding: theme.spacing(0.7, 0),
    backgroundColor: theme.palette.corporateGreen.main,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.corporateGreen.dark,
    },
  },
  field: {
    "& label.Mui-focused": {
      color: theme.palette.corporateGreen.main,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: theme.palette.corporateGreen.main,
    },
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.grey["800"],
    },
    "& :first-child": {
      marginRight: theme.spacing(2),
    },
  },
});

export default loginFormStyles;
